export default class SearchMulti {
  constructor(expr) {
    this.exprArr = expr.split(' ').sort((a, b) => b.length - a.length);
  }

  match(text) {
    const textArr = text.split(' ');

    return this.exprArr.every((exprWord) =>
      textArr.some(
        (textWord, i) => textWord.includes(exprWord) && textArr.splice(i, 1)
      )
    );
  }
}
